import { render, staticRenderFns } from "./DialogLegalAcceptance.vue?vue&type=template&id=63a36441&scoped=true"
import script from "./DialogLegalAcceptance.vue?vue&type=script&lang=js"
export * from "./DialogLegalAcceptance.vue?vue&type=script&lang=js"
import style0 from "./DialogLegalAcceptance.vue?vue&type=style&index=0&id=63a36441&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a36441",
  null
  
)

export default component.exports